import animateScrollTo from "animated-scroll-to";
import {preventDefault} from "@grrr/utils";

export const backToTop = function (el) {
    animateScrollTo(0, {
        easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
        minDuration: 1000,
        maxDuration: 2000,
        speed: 1000,
    });
};


export const toAnchor = function (el, evt) {
    console.log(document.querySelector('.topbar').getBoundingClientRect().height);
    preventDefault(evt);
    const link = el.dataset.anchorLink;
    animateScrollTo(document.querySelector('[data-anchor="' + link + '"]'), {
        easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
        minDuration: 1000,
        maxDuration: 2000,
        verticalOffset: -document.querySelector('.topbar').getBoundingClientRect().height + 1,
        speed: 1000,
    });
};

